// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oadi","importantInfo":"styles_importantInfo__2J_54"};